import React from 'react';
import { Heart } from 'lucide-react';

interface LikeButtonProps {
    likeStatus: boolean;
    handleLike: (e: React.MouseEvent) => void;
    size?: 'small' | 'normal';
}

const LikeButton = ({ likeStatus, handleLike, size = 'normal' }: LikeButtonProps) => {
    const padding = size === 'small' ? 'p-1.5' : 'p-2';
    const iconSize = size === 'small' ? 20 : 24;

    return (
        <button
            onClick={handleLike}
            className={`
                like-button
                ${padding}
                rounded-full
                bg-white
                border
                ${likeStatus ? 'border-red-200' : 'border-gray-200'}
                shadow-lg
                transition-all
                duration-300
                ease-in-out
                transform
                hover:scale-110
                hover:shadow-xl
                hover:shadow-pink-200/60
                hover:bg-pink-50
                active:scale-95
                ${likeStatus ? 'text-red-500' : 'text-gray-400 hover:text-pink-400'}
            `}
            title={likeStatus ? 'Unlike' : 'Like'}
        >
            <Heart
                size={iconSize}
                className="transition-transform duration-300 hover:scale-110"
                fill={likeStatus ? 'currentColor' : 'none'}
            />
        </button>
    );
};

export default LikeButton;
